import React, {useState} from 'react';
import JobMatchForm from "../talent-job-board/components/JobMatchForm";
import Opportunity from "../../models/Opportunity";
import {useOpportunity} from "../../providers/OpportunityProvider";

const MatchScoreEditTab = ({getStepActions = false}) => {

    const {
        opportunity,
        isDisabled,
        changeProps,
        onRequest
    } = useOpportunity();

    const [job, setJob] = useState(opportunity.relatedJob());

    return (
        <React.Fragment>
            {getStepActions && getStepActions(
                'Please review the client’s requirements compared to what’s in your profile.\n' +
                'If you have experience in missing areas (in gray), you can add them to your profile here.'
            )}

            <JobMatchForm
                disabled={isDisabled}
                onUpdateJob={updatedJob => {
                    let opp = Opportunity.make({
                        ...opportunity,
                        project_position: updatedJob
                    });
                    setJob(updatedJob);
                    changeProps(opp)
                }}
                onRequest={onRequest}
                job={job}/>


        </React.Fragment>
    );
};

export default MatchScoreEditTab;